import { render, staticRenderFns } from "./manageAssistantTeacherBar.vue?vue&type=template&id=15b3d87f&scoped=true&"
import script from "./manageAssistantTeacherBar.vue?vue&type=script&lang=js&"
export * from "./manageAssistantTeacherBar.vue?vue&type=script&lang=js&"
import style0 from "./manageAssistantTeacherBar.vue?vue&type=style&index=0&id=15b3d87f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b3d87f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBottomNavigation,VBtn,VIcon})
